import {TuiLanguagePreview} from '@taiga-ui/i18n/interfaces';

export const TUI_DANISH_LANGUAGE_ADDON_PREVIEW: TuiLanguagePreview = {
    previewTexts: {
        rotate: `Rotate`,
    },
    zoomTexts: {
        zoomOut: `Zoom out`,
        zoomIn: `Zoom in`,
        reset: `Reset`,
    },
};
